export const PATIENT_EVENTS_DEFAULT_SORT = {
  sortedColumn: 'createdAt',
  sortedColumnOrder: 'descend'
}
